var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{attrs:{"disabled":_vm.disabled || _vm.isLoadingApprove},on:{"click":_vm.approve}},[_vm._v(" "+_vm._s(_vm.$t('product.buttons.approve'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }